const bad = /[\u0000-\u0020\u007f\\]|%(?:0[0-9a-f]|1[0-9a-f]|7f|25(?:0[0-9a-f]|1[0-9a-f]|7f|25))/i;
export function paymentDestination(value, base = globalThis.location?.href) {
  if (typeof value !== 'string' || !value || value.length > 4096 || bad.test(value) || value.startsWith('//')) throw new Error('Invalid return URL');
  const current = new URL(base);
  const target = new URL(value,current);
  if (target.username || target.password || !['https:','http:'].includes(target.protocol)) throw new Error('Invalid return URL');
  const localHTTP = target.origin === current.origin && current.protocol === 'http:' && ['localhost','127.0.0.1','[::1]'].includes(current.hostname);
  if (target.protocol !== 'https:' && !localHTTP) throw new Error('HTTPS return URL required');
  return {url:target.href, external:target.origin !== current.origin, host:target.host};
}
export function localAuthDestination(value, fallback = '/dashboard', base = globalThis.location?.href) {
  try {
    if (typeof value !== 'string' || !value || value.length > 4096 || bad.test(value) || value.startsWith('//')) return fallback;
    const current = new URL(base), target = new URL(value,current);
    if (target.origin !== current.origin || target.username || target.password || !['https:','http:'].includes(target.protocol)) return fallback;
    return target.pathname+target.search+target.hash;
  } catch { return fallback; }
}
export function createRedirectController(navigate, base) {
  let started = false, stopped = false, generation = 0;
  return {
    activate() {if(stopped)started=false;stopped=false;},
    cancel() {stopped=true;generation++;},
    async run(value, beforeNavigate = async () => {}) {
      const target = paymentDestination(value,base);
      if (started || stopped) return false;
      started=true;
      const currentGeneration=generation;
      try {
        await beforeNavigate(target);
        if (stopped || generation !== currentGeneration) return false;
        navigate(target.url);
        return true;
      } catch(error) {if(generation === currentGeneration)started=false;throw error;}
    },
  };
}
